/* global $ */
class Base {
  constructor() {
    this.base = {};
    this.init();
  }

  init() {
    this.base = $('#database').data('peers');
    document.getElementsByTagName('body')[0].removeChild(document.getElementById('database'));
  }

}
export default new Base();



// WEBPACK FOOTER //
// ./public/scripts/webpack/bases.js